import React from 'react';

import { Block } from '../common/Block.jsx';
import { Builder, EditorContainer } from './Builder.jsx';
import { Clickable, Hoverable, HoverableLink, Link } from '../common/Button.jsx';
import Defaults from './Defaults.jsx';
import { FormContainer } from '../common/Form.jsx';
import FormField from '../common/FormField.jsx';
import { Text } from '../common/Input.jsx';
import Layout from '../common/Layout.jsx';
import PageType from '../common/PageType.jsx';
import Name from '../common/Name.jsx';
import Token from '../common/Token.jsx';
import Url from '../common/Url.jsx';
import Utilities from '../common/Utilities.jsx';

const HeaderUtilities = {
    checkForBlocks: function (blocks, types, _found) {
        if (!blocks || !types) {
            return;
        }
        const _types = new Set(types);
        let found = _found || [];
        let temp;
        for (let i = 0; i < blocks.length; i++) {
            temp = blocks[i];
            if (!temp || !temp.type) {
                continue;
            }
            if (_types.has(temp.type.value)) {
                found.push(temp);
            }
            if (temp.blocks) {
                for (let j = 0; j < temp.blocks.length; j++) {
                    HeaderUtilities.checkForBlocks(temp.blocks[j], types, found);
                }
            }
        }
        return found;
    }
}

function HeaderContainer(props) {
    const config = props.config || {};
    let blocks = [];
    const contentConfig = props.contentConfig;
    const hasHeaderDocument = contentConfig && contentConfig[props.type];
    if (hasHeaderDocument && contentConfig[props.type].blocks) {
        blocks = contentConfig[props.type].blocks;
    }
    let className = `nav nav--whitelabel nav--whitelabel--${props.type}`;
    if (props.disabled) {
        className += ' disabled';
    }
    let containerProps;
    if (hasHeaderDocument && contentConfig[props.type].page) {
        containerProps = { config: contentConfig[props.type].page.config };
    }

    // Mobile Toggle
    const [mobileNavVisible, setMobileNavVisible] = React.useState(false);

    // Search Bar
    const refSearchBar = React.useRef(undefined);
    const [searchBarVisible, setSearchBarVisible] = React.useState(false);
    const handleSearchToggle = function () {
        const visible = !searchBarVisible;
        setSearchBarVisible(visible);
        if (!visible || !refSearchBar.current) {
            return;
        }
        refSearchBar.current.focus();
    }

    let pageProps;
    if (props.onPageProps) {
        pageProps = props.onPageProps();
    } else {
        pageProps = containerProps;
    }
    let backgroundColor = config.colors && config.colors.navBackground;
    if (pageProps && pageProps.config && pageProps.config.block && pageProps.config.block.backgroundColor) {
        backgroundColor = pageProps.config.block.backgroundColor;
    }
    const handleBlockProps = (d) => {
        if (!d || !d.type) {
            return {};
        }
        const blockProps = { backgroundColor };
        switch (d.type.value) {
            case Name.Block.Header.MenuItemsV1:
            case Name.Block.Header.MenuItemsV2:
                blockProps.mainContentId = props.mainContentId;
                blockProps.pageId = props.pageId;
                break;
            case Name.Block.Header.MobileToggle:
                blockProps.pageId = props.pageId;
                blockProps.visible = mobileNavVisible;
                blockProps.onToggle = setMobileNavVisible;
                break;
            case Name.Block.Header.SearchToggleV2:
                blockProps.isV2 = true;
            // Intentional fallthrough
            case Name.Block.Header.SearchToggleV1:
                blockProps.onClick = handleSearchToggle;
                break;
        }
        return blockProps;
    };
    const handleBuilderBlockProps = (d, blockConfig, parentProps) => {
        const builderBlockProps = Builder.handleBlockProps(d, blockConfig, parentProps);;
        if (!d || !d.type) {
            return builderBlockProps
        }
        switch (d.type.value) {
            case Name.Block.Header.MobileToggle:
                builderBlockProps.frameDoc = props.frameDoc;
                builderBlockProps.isActiveBlock = props.activeConfigBlock && props.activeConfigBlock.type && props.activeConfigBlock.type.value == Name.Block.Header.MobileToggle;
                break;
        }
        return builderBlockProps;
    }

    // console.log(`header (${props.type}) background color: ${backgroundColor}`);

    const searchBarStyle = { backgroundColor };
    let containerStyle;
    if (pageProps && pageProps.config && pageProps.config.block && pageProps.config.block.position == 'fixed') {
        if (props.builder) {
            containerStyle = { position: 'relative' };
        } else {
            className += ' nav--fixed';
        }
        const pageTopOffset = pageProps.config.block.pageTopOffset;
        if (props.editor) {
            searchBarStyle.position = 'absolute';

            if (pageTopOffset != undefined && pageTopOffset.unit) {
                let value = parseFloat(pageTopOffset.value);
                if (!isNaN(value)) {
                    value += 4.0;
                    searchBarStyle.top = `${value}${pageTopOffset.unit}`;
                }
            }
            if (!searchBarStyle.top) {
                searchBarStyle.top = '0px';
            }
        } else {
            searchBarStyle.position = 'fixed';
            if (pageTopOffset != undefined && pageTopOffset.unit) {
                searchBarStyle.top = `${pageTopOffset.value}${pageTopOffset.unit}`;
            } else {
                searchBarStyle.top = '0px';
            }
        }
    } else if (props.editor) {
        searchBarStyle.marginTop = '-4px';
    }
    const handleMapStyleConfigProp = (_, propName, propValue) => {
        switch (propName) {
            case 'pageTopOffset':
                return true;
            case 'position':
                if (propValue == 'fixed' || props.builder) {
                    return true;
                }
                break;
        }
    }
    const handleContent = (content, style, contentProps) => {
        if (props.builder) {
            const contentClassName = contentProps.className;
            contentProps.className = 'nav--whitelabel--droparea';
            return <div className={contentClassName} style={style}>{content}</div>
        }
        Utilities.copyObject(style, contentProps.style);
        return (
            <div className='nav--content'>
                {content}
            </div>
        );
    }
    let handleSearchBarClick, searchBlockConfig;
    const searchBlockConfigs = HeaderUtilities.checkForBlocks(blocks, [Name.Block.Header.SearchToggleV1, Name.Block.Header.SearchToggleV2]);
    const hasSearch = searchBlockConfigs.length > 0;
    if (hasSearch) {
        if (props.activeConfigBlock && props.activeConfigBlock.type && props.activeConfigBlock.type.value == Name.Block.Header.SearchToggleV2) {
            searchBlockConfig = props.activeConfigBlock;
        } else {
            for (let i = 0; i < searchBlockConfigs.length; i++) {
                if (searchBlockConfigs[i].type.value != Name.Block.Header.SearchToggleV2) {
                    continue;
                }
                searchBlockConfig = searchBlockConfigs[i];
                break;
            }
        }
        handleSearchBarClick = () => {
            if (!searchBlockConfig) {
                return;
            }
            props.onBlockClick(searchBlockConfig.id)
        }
    }
    return (
        <React.Fragment>
            <EditorContainer
                {...props}
                blockPropsHandler={handleBlockProps}
                blocks={blocks}
                builderBlockPropsHandler={handleBuilderBlockProps}
                className={className}
                containerProps={containerProps}
                pageType={PageType.Header}
                style={containerStyle}
                updateBackgroundColor={false}
                onContainerProps={props.onPageProps}
                onContent={handleContent}
                onMapStyleConfigProp={handleMapStyleConfigProp} />
            {
                hasSearch &&
                <SearchBar
                    baseUrl={props.baseUrl}
                    blockConfig={searchBlockConfig && searchBlockConfig.config}
                    builder={props.builder}
                    config={config}
                    dataSub={props.queryDataSub}
                    editor={props.editor}
                    isV2={searchBlockConfig != undefined}
                    layout={props.queryLayout}
                    style={searchBarStyle}
                    sub={props.querySub}
                    type={props.type}
                    visible={searchBarVisible}
                    onClick={handleSearchBarClick}
                    onHide={() => setSearchBarVisible(false)}
                    onRef={refSearchBar} />
            }
        </React.Fragment>
    );
}

// #region CART

function CartLinkComponent(props) {
    if (!props.config || !props.config.isStripeConnected) {
        return null;
    }
    let className = `cart__holder cart__holder--${props.type || 'desktop'}`;
    let style;
    if (props.builder) {
        className += ' builder';
        style = { pointerEvents: 'none' };
    } else if (props.disabled) {
        style = { pointerEvents: 'none' };
    }
    if (props.blockConfig && props.blockConfig.layout) {
        if (!style) {
            style = {};
        }
        Block.mapStyleConfigProps(style, props.blockConfig.layout);
    }
    return (
        <div className={className} style={style}>
            <a className="cart__btn" href="/buy/" aria-label="Shopping Cart"><div className="ion ion-bag cart__btn--icon" /><span className="cart__counter" /></a>
        </div>
    );
}
const CartLink = { Component: CartLinkComponent };

// #endregion CART

// #region NAVIGATION MENU

function MenuItem(props) {
    let activeColor, hoverColor, itemDesign, submenuBackgroundColor, submenuDesign;
    let style = {};
    if (props.blockConfig && props.blockConfig.block) {
        Block.mapStyleConfigProps(style, props.blockConfig.block, (propName, propValue, propUnit) => {
            switch (propName) {
                case 'colorActive':
                    activeColor = propValue;
                    return true;
                case 'colorHover':
                    hoverColor = propValue;
                    return true;
                case 'colorSubmenuBackground':
                    submenuBackgroundColor = propValue;
                    return true;
                case 'design':
                    itemDesign = Layout.editorTextInternals(propValue);
                    return true;
                case 'designSubmenu':
                    submenuDesign = Layout.editorTextInternals(propValue);
                    return true;
                case 'menuItemSpacing':
                    if (propValue && propUnit) {
                        let value = `${propValue}${propUnit}`;
                        switch (props.textAlign) {
                            case 'center':
                                value = `${propValue / 2}${propUnit}`;
                                style.marginLeft = value;
                                style.marginRight = value;
                                break;
                            case 'right':
                                if (!props.isFirstItem) {
                                    style.marginLeft = value;
                                }
                                break;
                            case 'left':
                            default:
                                if (!props.isLastItem) {
                                    style.marginRight = value;
                                }
                                break;
                        }
                    }
                    return true;
            }
        });
    }
    let className = 'nav__menu__anch';
    let design;
    if (itemDesign) {
        className += ' richText';
        design = Token.parseTokenizedString(itemDesign, () => props.data.title);
        if (!submenuDesign) {
            submenuDesign = itemDesign;
        }
    } else {
        design = `<span>${props.data.title}</span>`;
    }
    if (props.builder || props.disabled) {
        style.pointerEvents = 'none';
    }
    let hoverProps;
    let LinkComponent = Link;
    if (hoverColor) {
        hoverProps = { design: Utilities.injectStyleIntoString(design, `color:${hoverColor};`) }
        LinkComponent = HoverableLink;
    }
    if (props.data.type && props.data.type.value == Layout.Type.Page.ExternalLink) {
        // External Link
        return (
            <LinkComponent
                className={className}
                contentClassName="p"
                design={design}
                href={props.data.relativeUrl}
                hoverProps={hoverProps}
                style={style}
                target={Url.getExternalLinkTarget(props.data)} />
        );
    }
    const isActive = props.hasPageConfig && props.data.pageId == props.activePageId;
    const subpages = props.data.subpages || [];
    if (subpages.length == 0 && (props.data.type && props.data.type.value != Layout.Type.Page.Group)) {
        // No sub pages and not a Group
        if (isActive) {
            if (activeColor) {
                design = Utilities.injectStyleIntoString(design, `color:${activeColor};`);
            } else {
                className += ' nav__menu__anch--active';
            }
            hoverProps = undefined;
        }
        return (
            <LinkComponent
                className={className}
                contentClassName="p"
                design={design}
                href={Url.getLink(props.baseUrl, props.data.relativeUrl, { sub: props.sub, layout: props.layout, dataSub: props.dataSub }, props.builder)}
                hoverProps={hoverProps}
                style={style} />
        );
    }
    const [expanded, setExpanded] = React.useState(false);
    React.useEffect(() => {
        if (!props.isFrancisco || !props.hasPageConfig) {
            return;
        }
        if (props.data.pageId == props.activePageId) {
            setExpanded(true);
        } else {
            for (let i = 0; i < subpages.length; i++) {
                if (subpages[i].pageId != props.activePageId) {
                    continue;
                }
                setExpanded(true);
                break;
            }
        }
    }, []);
    const hide = (event) => {
        if (event) {
            event.stopPropagation();
        }
        setExpanded(false);
    }
    const content = [];
    if (props.data.type && props.data.type.value != Layout.Type.Page.Group) {
        let contentClassName = 'drop__inn__anch';
        let contentDisplay;
        if (submenuDesign) {
            contentClassName += ' richText';
            contentDisplay = Token.parseTokenizedString(submenuDesign, () => props.data.title);
        } else {
            contentDisplay = `<span>${props.data.title}</span>`;
        }
        if (isActive) {
            if (activeColor) {
                contentDisplay = Utilities.injectStyleIntoString(contentDisplay, `color:${activeColor};`);
            } else {
                contentClassName += ' drop__inn__anch--active';
            }
            hoverProps = undefined;
        } else if (hoverColor) {
            hoverProps = { design: Utilities.injectStyleIntoString(contentDisplay, `color:${hoverColor};`) }
        }
        content.push(
            <LinkComponent
                key="-1"
                className={contentClassName}
                contentClassName="p"
                design={contentDisplay}
                href={Url.getLink(props.baseUrl, props.data.relativeUrl, { sub: props.sub, layout: props.layout, dataSub: props.dataSub }, props.builder)}
                hoverProps={hoverProps} />
        );
    }
    subpages.forEach(d => {
        let subpageClassName = 'drop__inn__anch';
        let subpageDisplay;
        if (submenuDesign) {
            subpageClassName += ' richText';
            subpageDisplay = Token.parseTokenizedString(submenuDesign, () => d.title);
        } else {
            subpageDisplay = `<span>${d.title}</span>`;
        }
        if (hoverColor) {
            hoverProps = { design: Utilities.injectStyleIntoString(subpageDisplay, `color:${hoverColor};`) }
        }
        if (d.type && d.type.value == Layout.Type.Page.ExternalLink) {
            // External Link
            content.push(
                <LinkComponent
                    key={d.pageId}
                    className={subpageClassName}
                    contentClassName="p"
                    design={subpageDisplay}
                    href={d.relativeUrl}
                    hoverProps={hoverProps}
                    target={Url.getExternalLinkTarget(d)}
                    onClick={(e) => {
                        if (e) {
                            e.stopPropagation();
                        }
                        setExpanded(false);
                    }} />
            );
            return;
        }
        if (props.hasPageConfig && d.pageId == props.activePageId) {
            if (activeColor) {
                subpageDisplay = Utilities.injectStyleIntoString(subpageDisplay, `color:${activeColor};`);
            } else {
                subpageClassName += ' drop__inn__anch--active';
            }
            hoverProps = undefined;
        }
        content.push(
            <LinkComponent
                key={d.pageId}
                className={subpageClassName}
                contentClassName="p"
                design={subpageDisplay}
                href={Url.getLink(props.baseUrl, d.relativeUrl, { sub: props.sub, layout: props.layout, dataSub: props.dataSub }, props.builder)}
                hoverProps={hoverProps} />
        );
    })
    let index = design.indexOf('</span>');
    if (index >= 0) {
        design = design.substring(0, index) + `&nbsp;<span class="i i-arrow-bottom"></span>` + design.substring(index);
    }
    LinkComponent = Clickable;
    if (hoverColor) {
        hoverProps = undefined;
        hoverProps = { design: Utilities.injectStyleIntoString(design, `color:${hoverColor};`) }
        LinkComponent = Hoverable;
    }
    let dropClassName = 'drop nav__menu__anch';
    if (expanded) {
        dropClassName += ' drop--active';
        style.zIndex = 2;
    }
    className = 'drop__anch';
    if (itemDesign) {
        className += ' richText';
    }
    return (
        <div className={dropClassName} style={style} onClick={() => setExpanded(true)}>
            <LinkComponent
                className={className}
                contentClassName="p"
                design={design}
                hoverProps={hoverProps}
                role="button"
                style={props.builder ? { pointerEvents: 'none' } : undefined} />
            {
                expanded &&
                !props.isFrancisco &&
                <div className="drop--dismiss" onClick={hide}></div>
            }
            <div className="drop__inn">
                <div className="drop__inn__holder" style={{ backgroundColor: submenuBackgroundColor }}>
                    {content}
                </div>
            </div>
        </div>
    );
}

function MenuItemsComponent(props) {
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({}, props);
    const pages = Layout.navPages(props.config);
    const hasPageConfig = props.pageId != undefined && props.pageId > 0;
    const textAlign = layoutStyles.style.textAlign || 'left';
    const menuItems = pages.map((d, i) => (
        <MenuItem
            key={d.pageId}
            activePageId={props.pageId}
            baseUrl={props.baseUrl}
            blockConfig={props.blockConfig}
            builder={props.builder}
            data={d}
            dataSub={props.queryDataSub}
            disabled={props.disabled}
            hasPageConfig={hasPageConfig}
            isFirstItem={i == 0}
            isLastItem={i == pages.length - 1}
            layout={props.queryLayout}
            sub={props.querySub}
            textAlign={textAlign} />
    ));
    if (props.type == 'legacy') {
        return <React.Fragment>{menuItems}</React.Fragment>;
    }
    let className = 'nav__menu';
    if (props.builder) {
        className += ' builder';
    }
    let content = (
        <div className={className} style={layoutStyles.style}>
            <a href={`#${props.mainContentId}`} className="drop__anch nav--skip__link" aria-label="Skip To Main Content"></a>
            {menuItems}
        </div>
    );
    if (layoutStyles.containerStyle) {
        content = <div className="nav__menu--cont" style={layoutStyles.containerStyle}>{content}</div>
    }
    return content;
}
const MenuItems = { Component: MenuItemsComponent };

// #endregion NAVIGATION MENU

// #region SEARCH

function SearchBar(props) {
    // Text
    const [text, setText] = React.useState('');
    React.useEffect(() => {
        if (!window || !window.location || !window.location.search) {
            return;
        }
        const query = Utilities.parseQueryString(window.location.search.substring(1));
        if (query) {
            setText(query.q);
        }
    }, []);
    const handleSubmit = function () {
        if (!window || !window.location || !text) {
            return;
        }
        const url = Url.getLink(props.baseUrl, 'search', { q: text, sub: props.sub, layout: props.layout, dataSub: props.dataSub });
        window.location.href = url;
    }

    // Height
    const [height, setHeight] = React.useState(undefined);
    const hide = () => {
        if (props.legacy) {
            return;
        }
        props.onHide();
    }
    React.useEffect(() => {
        if (props.builder) {
            return;
        }
        if (props.legacy) {
            setHeight(55);
            return;
        }
        let temp = document.getElementsByClassName('search--whitelabel');
        if (!temp || temp.length == 0) {
            hide();
            return;
        }
        temp = temp[0].getElementsByClassName('form--whitelabel');
        if (!temp || temp.length == 0) {
            hide();
            return;
        }
        temp = temp[0]
        if (temp.getClientRects) {
            const rects = temp.getClientRects();
            if (rects.length > 0) {
                setHeight(rects[0].height);
            } else {
                setHeight(55)
            }
        } else {
            setHeight(temp.clientHeight);
        }
        hide();
    }, []);


    let className = `search search--main search--row search--${props.type || 'desktop'}`;
    if (props.className) {
        className += ` ${props.className}`;
    }
    const style = props.style || {};
    style.marginTop = 0;
    style.transform = `translateY(0)`;
    if (props.visible || props.editor) {
        className += ' search--active';
        if (height) {
            style.height = `${height}px`;
            style.marginTop = `-${height}px`;
            style.transform = `translateY(${height}px)`;
        }
    }
    let editor, handleClick;
    if (props.builder) {
        className += ' builder';
        if (props.parentBlock == undefined) {
            handleClick = props.onClick;
        } else {
            className += ' builder-editor';
            editor = true;
            style.overflow = 'visible';
        }
        style.transition = 'none';
    }
    let contentConfig = props.contentConfig;
    if (props.isV2 && !contentConfig) {
        if (props.blockConfig && props.blockConfig.layout && props.blockConfig.layout.searchBarDesign && props.blockConfig.layout.searchBarDesign.desktop && props.blockConfig.layout.searchBarDesign.desktop.blocks && props.blockConfig.layout.searchBarDesign.desktop.blocks.length > 0) {
            contentConfig = props.blockConfig.layout.searchBarDesign;
        } else {
            contentConfig = Defaults.Block[Name.Block.Header.SearchBar.Container];
        }
    }
    let content;
    if (contentConfig) {
        className += ' search--whitelabel';
        if (contentConfig.desktop.page && contentConfig.desktop.page.config && contentConfig.desktop.page.config.block) {
            style.backgroundColor = contentConfig.desktop.page.config.block.backgroundColor;
        }
        const handleFormFieldProps = ({ type }, formFieldProps) => {
            switch (type) {
                case FormField.Search:
                    formFieldProps.placeholderText = 'Search by keyword, artist name, artwork title or exhibition';
                    formFieldProps.onSubmit = handleSubmit;
                    break;
                case FormField[Name.Block.Header.SearchBar.Container].SubmitButtonV1:
                case FormField[Name.Block.Header.SearchBar.Container].SubmitButtonV2:
                    formFieldProps.onClick = handleSubmit;
                    break;
            }
        }
        content = (
            <FormContainer.Component
                {...props}
                blockPropsHandler={() => true}
                contentConfig={contentConfig}
                editor={editor}
                formData={{ q: text }}
                onChange={(_, value) => setText(value)}
                onFormFieldProps={handleFormFieldProps} />
        )
    } else {
        content = (
            <div className="cont">
                <form className="search--row__form" onSubmit={(e) => { e.preventDefault(); handleSubmit() }}>
                    <Text
                        className="search--row__field"
                        name="q"
                        placeholder="Search by keyword, artist name, artwork title or exhibition"
                        value={text}
                        onChange={(_, value) => setText(value)}
                        onRef={props.onRef} />
                    <Clickable className="search--row__btn btn btn--fill btn--light" onClick={handleSubmit}>Search</Clickable>
                </form>
            </div>
        )
    }
    return (
        <div className={className} style={style} onClick={handleClick}>
            {content}
        </div>
    );
}

function SearchToggleComponent(props) {
    let className = `search__holder search__holder--${props.type || 'desktop'}`;
    let style;
    if (props.builder) {
        className += ' builder';
        style = { pointerEvents: 'none' };
    } else if (props.disabled) {
        style = { pointerEvents: 'none' };
    }
    let buttonStyle;
    if (props.blockConfig && props.blockConfig.layout) {
        if (!style) {
            style = {};
        }
        Block.mapStyleConfigProps(style, props.blockConfig.layout, (propName, propValue) => {
            switch (propName) {
                case 'color':
                    if (propValue && propValue.length > 0) {
                        buttonStyle = { color: 'inherit' };
                    }
                    break;
                case 'searchBarDesign':
                    return true;
            }
        });
    }
    return (
        <div className={className} style={style}>
            <Clickable
                aria-label="Search"
                className="search__btn"
                style={buttonStyle}
                onClick={props.onClick}>
                <div className="i i-search search__btn--icon" />
            </Clickable>
        </div>
    );
}
const SearchToggle = { Component: SearchToggleComponent };

// #endregion SEARCH

// #region NAV MOBILE

function NavMobile(props) {
    const [editorStyle, setEditorStyle] = React.useState(undefined);
    React.useEffect(() => {
        if (!props.editor || !props.builderBlockProps || !props.builderBlockProps.frameDoc) {
            return;
        }
        let element = props.builderBlockProps.frameDoc.getElementById('frameContent');
        if (!element || !element.children) {
            return;
        }
        element = element.children[element.children.length - 1];
        const offset = element.offsetHeight + element.offsetTop;
        setEditorStyle({ height: `calc(100% - ${top}px)`, top: offset, transition: 'none' })
    }, [])
    let className = 'nav--mobile';
    if (props.visible) {
        className += ' nav--mobile--active';
    }
    if (props.editor) {
        className += ' nav--mobile--editor';
    }
    let style = {};
    let colorActive, colorHover, colorLink, design, menuItemSpacing;
    if (props.blockConfig && props.blockConfig.layoutMenu) {
        Block.mapStyleConfigProps(style, props.blockConfig.layoutMenu, (propName, propValue, propUnit) => {
            switch (propName) {
                case 'colorActive':
                    colorActive = propValue;
                    return true;
                case 'colorHover':
                    colorHover = propValue;
                    return true;
                case 'design':
                    design = propValue;

                    const extractedStyle = Utilities.extractStyle(design);
                    if (extractedStyle) {
                        let testString = 'color:';
                        let startIndex;
                        if (extractedStyle.startsWith(testString)) {
                            startIndex = testString.length;
                        } else {
                            testString = `;${testString}`;
                            startIndex = extractedStyle.indexOf(testString);
                        }
                        if (startIndex != undefined) {
                            const endIndex = extractedStyle.indexOf(';');
                            if (endIndex < 0) {
                                colorLink = extractedStyle.substring(startIndex);
                            } else {
                                colorLink = extractedStyle.substring(startIndex, endIndex);
                            }
                        }
                    }
                    return true;
                case 'menuItemSpacing':
                    if (propValue && propValue.length > 0) {
                        menuItemSpacing = `${propValue}${propUnit}`;
                    }
                    return true;
            }
        })
    }
    const handleDesignProps = (title) => {
        let className = 'nav--mobile__anch';
        let _design;
        if (design) {
            className += ' richText';
            _design = Token.parseTokenizedString(design, () => title);
        } else {
            _design = `<span>${title}</span>`;
        }
        let hoverProps;
        let LinkComponent = Link;
        if (colorHover) {
            hoverProps = { design: Utilities.injectStyleIntoString(_design, `color:${colorHover};`) }
            LinkComponent = HoverableLink;
        }
        return { className, colorActive, colorLink, design: _design, hoverProps, LinkComponent }
    }
    const pages = Layout.navPages(props.config, NaN, false);
    let homeLink;
    if (!props.hasHomePage) {
        const designProps = handleDesignProps('Home')
        homeLink = (
            <designProps.LinkComponent
                className={designProps.className}
                design={designProps.design}
                href={Url.getHomeLink(props.baseUrl, props.sub, props.queryLayout, props.queryDataSub, props.builder)}
                hoverProps={designProps.hoverProps}
                style={{ marginBottom: menuItemSpacing }} />
        )
    }
    return (
        <div className={className} style={editorStyle}>
            <div className="nav--mobile__menu" style={style}>
                {homeLink}
                {
                    pages.map((d) => (
                        <MobileMenuItem
                            key={d.pageId}
                            activePageId={props.pageId}
                            baseUrl={props.baseUrl}
                            builder={props.builder}
                            data={d}
                            dataSub={props.queryDataSub}
                            layout={props.queryLayout}
                            menuItemSpacing={menuItemSpacing}
                            sub={props.querySub}
                            onDesignProps={handleDesignProps} />
                    ))
                }
            </div>
        </div>
    );
}

function MobileMenuItem(props) {
    const content = [];
    if (props.data.subpages && props.data.subpages.length > 0) {
        content.push(<MobileMenuAccordion key={props.data.pageId} {...props} />);
    } else if (props.data.type) {
        const designProps = props.onDesignProps(props.data.title);
        const style = { marginBottom: props.menuItemSpacing || '24px' };
        let design = designProps.design;
        if (props.activePageId == props.data.pageId) {
            design = Utilities.injectStyleIntoString(design, `color:${designProps.colorActive};`)
        }
        if (props.data.type.value == Layout.Type.Page.ExternalLink) {
            // External Link
            content.push(
                <designProps.LinkComponent
                    key={props.data.pageId}
                    className={designProps.className}
                    design={design}
                    href={props.data.relativeUrl}
                    hoverProps={designProps.hoverProps}
                    style={style}
                    target={Url.getExternalLinkTarget(props.data)} />
            );
        } else if (props.data.type.value != Layout.Type.Page.Group) {
            // not a group link
            content.push(
                <designProps.LinkComponent
                    key={props.data.pageId}
                    className={designProps.className}
                    design={design}
                    href={Url.getLink(props.baseUrl, props.data.relativeUrl, { sub: props.sub, layout: props.layout, dataSub: props.dataSub }, props.builder)}
                    hoverProps={designProps.hoverProps}
                    style={style} />
            );
        } else {
            // group link
            content.push(
                <div key={props.data.pageId}
                    className={`${designProps.className} nav--mobile__anch--group`}
                    dangerouslySetInnerHTML={{ __html: design }}
                    style={style} />
            );
        }
    }
    return content;
}

function MobileMenuAccordion(props) {
    const [openMenu, setOpenMenu] = React.useState(false);
    const header = [];
    const items = [];

    const [heightCalcHandle, setHeightCalcHandle] = React.useState(undefined);
    const [submenuHeight, setSubmenuHeight] = React.useState(undefined);
    const submenuRef = React.useRef(undefined);
    React.useEffect(() => {
        if (!submenuRef || !submenuRef.current || submenuHeight) {
            return;
        }
        if (heightCalcHandle) {
            clearTimeout(heightCalcHandle);
        }
        setSubmenuHeight('0px');
        setHeightCalcHandle(setTimeout(() => {
            if (!submenuRef || !submenuRef.current || !submenuRef.current.children) {
                return;
            }
            let marginBottom = 25;
            const menuItemSpacing = parseInt(props.menuItemSpacing, 10)
            if (!isNaN(menuItemSpacing)) {
                marginBottom = menuItemSpacing + 1;
            }
            let height = marginBottom * submenuRef.current.children.length;
            for (let i = 0; i < submenuRef.current.children.length; i++) {
                height += submenuRef.current.children[i].offsetHeight;
            }
            setSubmenuHeight(`${height}px`)
        }, 100));
    }, [submenuRef])

    const designProps = props.onDesignProps(props.data.title);
    if (props.data.type) {
        let design = designProps.design;
        if (props.activePageId == props.data.pageId) {
            design = Utilities.injectStyleIntoString(design, `color:${designProps.colorActive};`)
        }
        if (props.data.type.value == Layout.Type.Page.ExternalLink) {
            // External Link
            header.push(
                <designProps.LinkComponent
                    key={props.data.pageId}
                    className={designProps.className}
                    design={design}
                    href={props.data.relativeUrl}
                    hoverProps={designProps.hoverProps}
                    target={Url.getExternalLinkTarget(props.data)} />
            );
        } else if (props.data.type.value != Layout.Type.Page.Group) {
            // not a group link
            header.push(
                <designProps.LinkComponent
                    key={props.data.pageId}
                    className={designProps.className}
                    design={design}
                    href={Url.getLink(props.baseUrl, props.data.relativeUrl, { sub: props.sub, layout: props.layout, dataSub: props.dataSub }, props.builder)}
                    hoverProps={designProps.hoverProps} />
            );
        } else {
            // group link
            header.push(
                <div key={props.data.pageId}
                    className={`${designProps.className} nav--mobile__anch--group`}
                    dangerouslySetInnerHTML={{ __html: design }}
                    onClick={() => setOpenMenu(!openMenu)} />
            );
        }
    }

    const subpages = props.data.subpages || [];
    const style = { marginBottom: props.menuItemSpacing || '24px' };
    subpages.forEach(subpage => {
        const designProps = props.onDesignProps(subpage.title);
        let design = designProps.design;
        if (props.activePageId == subpage.pageId) {
            design = Utilities.injectStyleIntoString(design, `color:${designProps.colorActive};`)
        }
        if (subpage.type && subpage.type.value == Layout.Type.Page.ExternalLink) {
            // External Link
            items.push(
                <designProps.LinkComponent
                    key={subpage.pageId}
                    className={designProps.className}
                    contentClassName="p"
                    design={design}
                    href={subpage.relativeUrl}
                    hoverProps={designProps.hoverProps}
                    style={style}
                    target={Url.getExternalLinkTarget(subpage)} />
            );
        } else {
            items.push(
                <designProps.LinkComponent
                    key={subpage.pageId}
                    className={designProps.className}
                    design={design}
                    href={Url.getLink(props.baseUrl, subpage.relativeUrl, { sub: props.sub, layout: props.layout, dataSub: props.dataSub }, props.builder)}
                    hoverProps={designProps.hoverProps}
                    style={style} />
            );
        }
    });

    return (
        <div className={`nav--mobile__submenu ${openMenu ? 'nav--mobile__submenu--active' : ''}`}>
            <div className="nav--mobile__submenu__header" style={style}>
                {header} <span className="nav--mobile__submenu__arrow i i-arrow-bottom" style={{ color: designProps.colorLink }} onClick={() => setOpenMenu(!openMenu)}></span>
            </div>
            <div className={`nav--mobile__submenu__items`} style={{ maxHeight: openMenu ? submenuHeight : 0 }} ref={submenuRef}>
                {items}
            </div>
        </div>
    );
}

function MobileToggleComponent(props) {
    const [restoreOffset, setRestoreOffset] = React.useState(0);
    const [navVisible, setNavVisible] = React.useState(false);
    const handleMenuToggle = function () {
        const visible = !navVisible;
        setNavVisible(visible);

        if (props.onToggle) {
            props.onToggle(visible);
        }

        if (!document.body) {
            return;
        }
        let className = document.body.className;
        if (className && className.indexOf('nav--mobile--opened') >= 0) {
            className = className.replace('nav--mobile--opened', '').trim();
        }
        if (visible) {
            setRestoreOffset(document.documentElement ? document.documentElement.scrollTop : document.body.scrollTop);
            document.body.scrollTop = 0;
            if (document.documentElement) {
                document.documentElement.scrollTop = 0;
            }
            if (!className) {
                className = 'nav--mobile--opened';
            } else {
                className += ' nav--mobile--opened';
            }
        } else {
            document.body.scrollTop = restoreOffset;
            if (document.documentElement) {
                document.documentElement.scrollTop = restoreOffset;
            }
        }
        document.body.className = className;
    }
    let className = `control__holder control__holder--${props.type}`;
    if (navVisible) {
        className += ' icon--close';
    }
    let style;
    if (props.builder) {
        className += ' builder';
        style = { pointerEvents: 'none' };
    } else if (props.disabled) {
        style = { pointerEvents: 'none' };
    }
    const closeButtonStyle = {};
    let iconBarStyle;
    if (props.blockConfig) {
        if (props.blockConfig.layout) {
            if (!style) {
                style = {};
            }
            Block.mapStyleConfigProps(style, props.blockConfig.layout, (propName, propValue, propUnit) => {
                switch (propName) {
                    case 'paddingBottom':
                    case 'paddingLeft':
                    case 'paddingRight':
                    case 'paddingTop':
                        if (propValue && propUnit) {
                            closeButtonStyle[propName] = `${propValue}${propUnit}`;
                        }
                        break;
                }
            });
        }
        if (props.visible && props.blockConfig.layoutMenu && props.blockConfig.layoutMenu.colorActive) {
            iconBarStyle = { backgroundColor: props.blockConfig.layoutMenu.colorActive };
        }
    }
    const hasHomePage = Layout.hasTypedPage(props.config, Layout.Type.Page.Home);
    return (
        <>
            {
                props.type == 'mobile' &&
                ((props.builderBlockProps && props.builderBlockProps.isActiveBlock) || (!props.builder && !props.disabled)) &&
                <NavMobile
                    baseUrl={props.baseUrl}
                    blockConfig={props.blockConfig}
                    builder={props.builder}
                    builderBlockProps={props.builderBlockProps}
                    config={props.config}
                    editor={props.editor}
                    hasHomePage={hasHomePage}
                    pageId={props.pageId}
                    queryDataSub={props.queryDataSub}
                    queryLayout={props.queryLayout}
                    querySub={props.querySub}
                    visible={props.visible} />
            }
            <div className={className} style={style}>
                <Clickable
                    aria-label="Menu"
                    onClick={handleMenuToggle}>
                    <div className="i i-burger" style={{ opacity: navVisible ? 0 : 1 }} />
                    <div className="i i-close" style={{ ...closeButtonStyle, opacity: navVisible ? 1 : 0 }} />
                </Clickable>
            </div>
        </>
    );
}
const MobileToggle = { Component: MobileToggleComponent };

// #endregion NAV MOBILE

export {
    CartLink,
    HeaderContainer,
    MenuItems,
    MobileToggle,
    NavMobile,
    SearchBar,
    SearchToggle,
    Utilities
};